import React, { useEffect, useState } from 'react'
import './DetailLand.scss'
import Slideshow from './components/slideshow/Slideshow'
import { Tag } from 'antd'
import { CheckCircleFilled } from '@ant-design/icons'
import LandService from '../../service/LandService'
import { useParams } from 'react-router-dom'

const DetailLand = () => {
    const { id } = useParams();
    const [detailLand, setDetailLand] = useState(null);

    const getDetailLand = async (landId) => {
        try {
            const response = await LandService.getDetail(landId);
            setDetailLand(response);
        } catch (error) {
            console.log('Failed to fetch detail land: ', error);
        }
    }

    useEffect(() => {
        getDetailLand(id);
    }, []);

    return (
        <div className='detail-land-container'>
            <Slideshow listImage={detailLand?.list_image_id}></Slideshow>

            <div className='breadcumb'></div>
            <div className='status'>
                <Tag className='tag' key={"status"} color={"success"} icon={null} variant={"outlined"}>
                Xác thực
                </Tag>
            </div>
            <div className='title'>{detailLand?.title}</div>
            <div className='address'>{detailLand?.address}</div>
            <div className='line'></div>
            <div className='info'>
                <div className='info__item'>
                    <div className='info__item-title'>Diện tích</div>
                    <div className='info__item-value'>{detailLand?.acreage}m²</div>
                    <div className='info__item-note'>{detailLand?.price/1000000/detailLand?.acreage} triệu/m2</div>
                </div>
                <div className='info__item'>
                    <div className='info__item-title'>Mặt tiền</div>
                    <div className='info__item-value'>{detailLand?.front_length}m</div>
                    {/* <div className='info__item-note'>Mặt tiền 8 m</div> */}
                </div>
                <div className='info__item'>
                    <div className='info__item-title'>Hướng</div>
                    <div className='info__item-value'>{detailLand?.direction}</div>
                    <div className='info__item-note'></div>
                </div>
                <div className='info__item'>
                    <div className='info__item-title'>Pháp lý</div>
                    <div className='info__item-value'>{detailLand?.legal}</div>
                    <div className='info__item-note'></div>
                </div>
            </div>
            <div className='description'>
                <div className='description-title'>Thông tin mô tả</div>
                <div className='description-content'>{detailLand?.description}</div>
            </div>
            <div className='confirm'>
                <div className='confirm-title'><CheckCircleFilled className='icon' color='#009BA1'></CheckCircleFilled>Batdongsanthanhoai đã xác thực</div>
            </div>
        </div>
    )
}

export default DetailLand